import gql from 'graphql-tag'
import HighLightsFragemt from './HighlightsFragment'
import BankCommentaryFragment from './BankCommentaryFragment'

export default gql`
  query PriorityNotesQuery($rid: Int!) {
    loan(rid: $rid, unscoped: true) {
      rid
      amount
      followers{
        rid
        name
      }
      adminsWithPermission{
        rid
        name
      }
      checklistItems{
        rid
        markAsRead
        description
      }
      helpfulHints {
        rid
        category
        description
      }
      bankCommentaries {
        ${BankCommentaryFragment}
      }
      highlights {
        ${HighLightsFragemt}
      }
    }
  }
`
